import { connect } from 'react-redux';
import get from 'lodash/get';
import SelectLanguage from './select-language';
import { setUserLocale } from 'routes/profile/profile-dux';
import { client, translations } from '@biw/contests-core';

export const mapStateToProps = state => ( {
    busyFetchingLocaleBundle: get( state, `data.fetching.${client.types.CLIENT_LOCALE_BUNDLE}`, false ),
    localeOptions: translations.selectors.getLocaleList( state ),
    locale: translations.selectors.getUserLocale( state )
} );

export const mapDispatchToProps = {
    selectLanguage: setUserLocale
};

export default connect( mapStateToProps, mapDispatchToProps )( SelectLanguage );
